<template>
  <div class="onboard-screen">
    <div class="icon" v-bind:style="{ 'background-color': color }">
      <slot name="icon"></slot>
    </div>
    <div class="content">
      <div class="md-title"><slot name="title"></slot></div>
    </div>
    <div class="md-caption"><div><slot name="content"></slot></div></div>
  </div>
</template>

<script>
export default {
  props: ["color"],
  data() {
    return {
      
    }
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Quicksand&display=swap');

.onboard-screen {
  .icon {
    position: absolute;
    top: 0;
    width: 100%;

    img {
      height: 35vh;
      margin-top: 5vh;
      padding-left: 50px;
      padding-right: 50px;
    }
  }
    .md-title, .md-caption {
      font-family: 'Quicksand', sans-serif;
    }

    .md-title{
      padding: 30px 50px;
      font-size: 30px;
      line-height: 1.5em;
    }

    .md-caption {
      position: absolute;
      padding: 0 30px;
      height: 50%;
      left: 0;
      font-size: 15px;
      line-height: 1.5em;
      width: 100%;

      button {
        margin-top: 20px;
        z-index: 20000;
      }
    }
}
</style>
